import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.interactive-launcher',
        container: '.interactive-launcher__container',
        iframeContainer: '.interactive-launcher__iframe-container',
        iframeWrapper: '.interactive-launcher__iframe-wrapper',
        iframe: '.interactive-launcher__iframe',
        cta: '.interactive-launcher__cta',
        close: '.interactive-launcher__close',
        text: '.interactive-launcher__text'
    },
    dataAttributes: {
        iframeSrc: 'iframe-src'
    },
    classNames: {
        fullscreen: 'interactive-launcher__iframe-wrapper--fullscreen'
    },
};

class InteractiveLauncher {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isInitialized = false;
        this._src = '';
    }

    init() {
        this._elements = this._getDomElements();

        if(true) {
            this._loadIframe();
        }

        this._addEventListeners();
    }

    _getDomElements() {
        return {
            $iframe: this._$rootElement.find(config.selectors.iframe), 
            $iframeWrapper: this._$rootElement.find(config.selectors.iframeWrapper), 
            $cta: this._$rootElement.find(config.selectors.cta), 
            $close: this._$rootElement.find(config.selectors.close), 
        };
    }

    _loadIframe() {
        this._elements.$iframe.attr('src', this._elements.$iframe.data(config.dataAttributes.iframeSrc));
    }


    _addEventListeners() {
        const _this = this;

        this._elements.$cta.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this._elements.$iframeWrapper.addClass(config.classNames.fullscreen);
        });

        this._elements.$close.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this._elements.$iframeWrapper.removeClass(config.classNames.fullscreen);
        });
    }
}

moduleRegistry.registerModule('InteractiveLauncher', InteractiveLauncher);
moduleRegistry.autoApplyModule('InteractiveLauncher', config.selectors.root);
